
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import S3BucketMixin from "@/mixins/storage/S3BucketMixins";
import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
import MessageNotification, { MessageDuration } from "@/data/notificationsMessages";
import Spinner from "@/components/common/Spinner.vue"

import { NOTIFICATION } from "@/entities/Events";

import { Message } from "@/generated/graphql";
import moment from "moment";

@Component({
  components: {
    CircleWithInitials,
    Spinner,
  }
})
export default class InboxMessage extends mixins(S3BucketMixin) {
  @Prop({type: Object, required: true}) readonly data!: Message;
  @Prop({type: Boolean, default: false}) readonly isGroupConversation!: boolean;
  @Prop({type: String, required: true}) readonly currentUserId!: string;
  @Prop({ type: String, default: undefined }) readonly uploadingAttachmentId!: string;

  get uploadingShown(): boolean {
    return this.uploadingAttachmentId === this.data.id;
  }

  get messageContent() {
    if (!this.data.content) {
      return [];
    }

    return this.data.content.split("<br />").filter(Boolean);
  }

  async mounted() {
    if (this.data.attachment) {
      await this.getFile(this.data.attachment);
    }
  }

  async handleDownload(filename: string): Promise<void> {
    try {
      const file = await this.getFilePath(filename);
      window.open(file, "_self");
    } catch (err) {
        this.$eventBus.emit(
        NOTIFICATION,
        MessageNotification.errorMessage(
          "Could not download the file. Please, try again later",
          MessageDuration.DEFAULT,
        ),
      );
    }
  }

  get filename(): string | undefined {
    const attachment = this.data.attachment;
    if (!attachment) {
      return;
    }

    const regex = new RegExp("[^.]+$");
    const extension = attachment.match(regex);
    const name = attachment
      .split(".")
      .slice(0, -1)
      .join(".")
      .substring(0, attachment.length - 41);
    return `${name}.${extension}`;
  }

  get messageContainerStyle(): string {
    return this.myself ? 'bg-chatMessage-sender' : 'border';
  }

  get avatarPosition(): string {
    return this.myself ? 'order-last relative bottom-5' : 'order-first -mt-1.5';
  }

  get messageContainerPosition(): string {
    return this.myself ? 'ml-auto justify-end' : 'mr-auto';
  }

  get messageDatePosition(): string {
    return this.myself ? 'ml-auto' : 'mr-auto';
  }

  get messageDate(): string {
    return moment(this.data.created_at).format('HH:mm A');
  }

  get isImage(): boolean{
    return /^.*\.(jpeg|JPEG|jpg|JPG|gif|GIF|png|PNG)$/.test(
      this.data.attachment!
    );
  }
  get myself(): boolean {
    return this.currentUserId === this.data.sender.id;
  }

  get senderName(): string {
    const {sender} = this.data;
    return `${sender.given_name} ${sender.family_name}`;
  }
}
